// @ts-nocheck
// Greif UI Kit = line-log-out-large, line-log-out-small
import * as React from "react";

const LogOut: React.FC = () => {
    /* Store Custom Code - Start */
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M14.653 6.99a1.064 1.064 0 0 1 1.505 0l4.258 4.258a1.1 1.1 0 0 1 .249.398l.015.042a1.1 1.1 0 0 1 .047.312l-.005.11q-.005.033-.011.066a1 1 0 0 1-.044.175 1.067 1.067 0 0 1-.252.401l-4.257 4.258a1.064 1.064 0 1 1-1.505-1.505l2.44-2.44H9.445a1.065 1.065 0 0 1 0-2.13h7.648l-2.44-2.44a1.064 1.064 0 0 1 0-1.505M10.51 4.337c0 .588-.477 1.064-1.065 1.064H6.04a.64.64 0 0 0-.639.64v11.918a.64.64 0 0 0 .64.64h3.404a1.064 1.064 0 1 1 0 2.128H6.04a2.77 2.77 0 0 1-2.767-2.768V6.04A2.77 2.77 0 0 1 6.04 3.273h3.405c.588 0 1.064.476 1.065 1.064"
            />
        </svg>
    );
    /* Store Custom Code - End */
};

export default React.memo(LogOut);
